import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  // Menu.assetInformation,
  Menu.assetChemicalEdit,
  Menu.assetChemicalDelete,
  Menu.searchAsset,
  // Menu.assetAlert,
  Menu.assetsHelp,
];
